import { useTranslation } from "react-i18next";
import { copyToClipboard } from "src/ui/utils/clipboard";
import { filesize } from "src/ui/utils/filesize";
import { makeStyles } from "tss-react/mui";

import { Typography } from "@mui/material";
import { SecondaryButton } from "@shared/CustomButton";
import { UncontrolledTextField } from "@shared/form/TextField";
import { Modal } from "@shared/Modal/Modal";

const useStyles = makeStyles()((theme) => ({
    textContainer: {
        display: "flex",
        alignItems: "center",
        marginTop: theme.spacing(2),
    },
    label: {
        minWidth: 120,
        maxWidth: 120,
    },
    copyButton: {
        marginLeft: theme.spacing(2),
    },
}));

interface Props {
    file: API.ReleaseFile;
    isOpen: boolean;
    toggleDialog: VoidFunction;
}

export const InformationModal = ({ file, isOpen, toggleDialog }: Props) => {
    const { classes } = useStyles();
    const { t } = useTranslation(["common", "modals"]);

    if (!isOpen) {
        return null;
    }

    return (
        <Modal open={isOpen} onClose={toggleDialog} title={t("modals:releaseDetails.title")}>
            <div className={classes.textContainer}>
                <Typography className={classes.label}>{t("common:label.codename")}</Typography>
                <UncontrolledTextField value={file.codename} disabled fullWidth />
            </div>
            <div className={classes.textContainer}>
                <Typography className={classes.label}>{t("common:label.size")}</Typography>
                <UncontrolledTextField value={filesize(file.size)} disabled fullWidth />
            </div>
            <div className={classes.textContainer}>
                <Typography className={classes.label}>{t("modals:releaseDetails.md5")}</Typography>
                <UncontrolledTextField value={file.hashMd5} disabled fullWidth />
                <SecondaryButton
                    className={classes.copyButton}
                    onClick={() => void copyToClipboard(file.hashMd5)}
                    tooltipProps={{ title: t("common:button.copy") }}
                    name="copy-md5"
                >
                    <i className="fa-solid fa-copy" />
                </SecondaryButton>
            </div>
            <div className={classes.textContainer}>
                <Typography className={classes.label}>{t("modals:releaseDetails.sha256")}</Typography>
                <UncontrolledTextField value={file.hashSha256} disabled fullWidth />
                <SecondaryButton
                    className={classes.copyButton}
                    onClick={() => void copyToClipboard(file.hashSha256)}
                    tooltipProps={{ title: t("common:button.copy") }}
                    name="copy-sha256"
                >
                    <i className="fa-solid fa-copy" />
                </SecondaryButton>
            </div>
        </Modal>
    );
};
